import Qs from 'qs'
import Constant from '@/Constant'

export default {
    baseURL: Constant.apiBaseUrl,
    method: 'GET',
    transformRequest: [
        function(data) {
            data = Qs.stringify(data);
            // data = JSON.stringify(data);
            return data;
        }
    ],

    transformResponse: [
        function(data) {
            return data;
        }
    ],

    headers: {
        'Accept': 'application/json,text/html',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        /* 'Content-Type': 'application/json;charset=UTF-8'*/
    },

    params: {},
    paramsSerializer: function(params) {
        return Qs.stringify(params)
    },

    timeout: 60000,
    withCredentials: false, // default
    responseType: 'json', // default

    //防止跨域状态下发起option请求
    // onUploadProgress: function(progressEvent) {
    //  // Do whatever you want with the native progress event
    // },
    // onDownloadProgress: function(progressEvent) {
    //  // Do whatever you want with the native progress event
    // },

    maxContentLength: 2000,
    validateStatus: function(status) {
        return status >= 200 && status < 500; // default
    },
    maxRedirects: 5, // default
}



// WEBPACK FOOTER //
// ./src/service/config.js